export const colors = {
  border: {
    dark: '#4f5b67', //rgb(79, 91, 103)
    focus: '#1a2937',
    hover: '#959da6',
    medium: '#c1c6cb', //rgb(193, 198, 203)
    light: '#dfe2e4'
  },
  canvas: {
    medium_dark: '#8B939B', //rgb(139, 147, 155)
    dark: '#394651', //rgb(57, 70, 81)
    darkest: '#1a2937', //rgb(26, 41, 55)
    light: '#f0f3f6', //rgb(240, 243, 246)
    medium: '#c1c6cb', //rgb(193, 198, 203)
    medium_light: '#e0e6ec', //rgb(224, 230, 236)
    white: '#ffffff' //rgb(255, 255, 255)
  },
  navigation: {
    activeBackground: '#25313b',
    inactiveBackground: '#394651',
    inactiveText: '#90abc3',
    borderLight: '#4a5b69',
    borderDark: '#283139',
    focus: '#b8860b'
  },
  text: {
    light: '#868686', //rgb(134, 134, 134)
    dark: '#4a4a4a' //rgb(74, 74, 74)
  },
  icon_medium: '#a9afb4', //rgb(169, 175, 180)
  states: {
    info: '#4169e1', //rgb(65, 105, 225),
    error: '#ff1800', //rgb(255, 24, 0)
    success: '#27ae60', //rgb(39, 174, 96)
    warning: '#f69033', //rgb(246, 144, 51)
    warning_complimentary: '#a86c09', //rgb(168, 108, 9)
    progress: '#9e9e9e' //rgb(158, 158, 158)
  },
  modules: {
    billing: '#319a8f',
    configuration: '#b8860b',
    customer: '#3e97cf',
    documentation: '#e91e63',
    ratingandcharging: '#5ea012',
    reporting: '#36a564',
    security: '#ef6c00',
    studio: '#ab4189',
    workbench: '#5640BE',
    neutral: '#1a2937'
  }
};

export const PALETTE = {
  ACTION: 'action',
  DISABLED: 'disabled',
  ERROR: 'error',
  INFO: 'info',
  INHERIT: 'inherit',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success'
};
